import axios from 'axios';

export const HTTP = axios.create({
  baseURL: ``,
  headers: {
   Authorization: 'Bearer mojtokenik'
  }
})
